import React, { useState } from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    propertyType: 'residential',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Here you would typically send the form data to your server
    console.log('Form submitted:', formData);
    setIsSubmitted(true);
  };
  return <section id="contact" className="py-16" data-id="element-44">
      <div className="container mx-auto px-4" data-id="element-45">
        <div className="text-center mb-12" data-id="element-46">
          <h2 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-47">Contact Us</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-48">
            Get in touch with our team to book an EICR inspection or ask any
            questions about our services.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-10" data-id="element-49">
          <div data-id="element-50">
            <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-51">
              Book an EICR Inspection
            </h3>
            {isSubmitted ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center" data-id="element-52">
                <CheckCircleIcon className="w-12 h-12 text-green-500 mx-auto mb-4" data-id="element-53" />
                <h4 className="text-xl font-semibold text-gray-800 mb-2" data-id="element-54">
                  Thank You!
                </h4>
                <p className="text-gray-600" data-id="element-55">
                  Your request has been submitted successfully. One of our team
                  members will contact you shortly.
                </p>
              </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-56">
                <div data-id="element-57">
                  <label htmlFor="name" className="block text-gray-700 font-medium mb-1" data-id="element-58">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-59" />
                </div>
                <div className="grid md:grid-cols-2 gap-4" data-id="element-60">
                  <div data-id="element-61">
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-62">
                      Email Address
                    </label>
                    <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-63" />
                  </div>
                  <div data-id="element-64">
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-65">
                      Phone Number
                    </label>
                    <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-66" />
                  </div>
                </div>
                <div data-id="element-67">
                  <label htmlFor="propertyType" className="block text-gray-700 font-medium mb-1" data-id="element-68">
                    Property Type
                  </label>
                  <select id="propertyType" name="propertyType" value={formData.propertyType} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-69">
                    <option value="residential" data-id="element-70">Residential</option>
                    <option value="commercial" data-id="element-71">Commercial</option>
                    <option value="industrial" data-id="element-72">Industrial</option>
                  </select>
                </div>
                <div data-id="element-73">
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-1" data-id="element-74">
                    Additional Information
                  </label>
                  <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-colors" data-id="element-75"></textarea>
                </div>
                <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded transition-colors" data-id="element-76">
                  Request EICR Inspection
                </button>
              </form>}
          </div>
          <div data-id="element-77">
            <div className="bg-gray-50 rounded-lg p-6" data-id="element-78">
              <h3 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-79">
                Contact Information
              </h3>
              <div className="space-y-4 mb-8" data-id="element-80">
                <div className="flex items-start" data-id="element-81">
                  <PhoneIcon className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-82" />
                  <div data-id="element-83">
                    <h4 className="font-semibold text-gray-800" data-id="element-84">Phone</h4>
                    <p className="text-gray-600" data-id="element-85">
                      <a href="tel:+441234567890" className="hover:text-blue-600 transition-colors" data-id="element-86">
                        01234 567890
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-87">
                  <MailIcon className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-88" />
                  <div data-id="element-89">
                    <h4 className="font-semibold text-gray-800" data-id="element-90">Email</h4>
                    <p className="text-gray-600" data-id="element-91">
                      <a href="mailto:info@safecircuit-eicr.co.uk" className="hover:text-blue-600 transition-colors" data-id="element-92">
                        info@safecircuit-eicr.co.uk
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-93">
                  <MapPinIcon className="w-5 h-5 text-blue-600 mr-3 mt-1 flex-shrink-0" data-id="element-94" />
                  <div data-id="element-95">
                    <h4 className="font-semibold text-gray-800" data-id="element-96">
                      Office Address
                    </h4>
                    <p className="text-gray-600" data-id="element-97">
                      123 Electric Avenue
                      <br data-id="element-98" />
                      London, EC1A 1BB
                      <br data-id="element-99" />
                      United Kingdom
                    </p>
                  </div>
                </div>
              </div>
              <div data-id="element-100">
                <h4 className="font-semibold text-gray-800 mb-3" data-id="element-101">
                  Business Hours
                </h4>
                <div className="space-y-2 text-gray-600" data-id="element-102">
                  <div className="flex justify-between" data-id="element-103">
                    <span data-id="element-104">Monday - Friday:</span>
                    <span data-id="element-105">8:00 AM - 6:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-106">
                    <span data-id="element-107">Saturday:</span>
                    <span data-id="element-108">9:00 AM - 4:00 PM</span>
                  </div>
                  <div className="flex justify-between" data-id="element-109">
                    <span data-id="element-110">Sunday:</span>
                    <span data-id="element-111">Closed</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-6 bg-blue-50 border border-blue-100 rounded-lg p-6" data-id="element-112">
              <h4 className="font-semibold text-gray-800 mb-3" data-id="element-113">
                Emergency Service
              </h4>
              <p className="text-gray-600 mb-4" data-id="element-114">
                Need an urgent EICR for a property completion or tenant move-in?
                Our emergency service ensures you get your certificate within 24
                hours.
              </p>
              <a href="tel:+441234567890" className="flex items-center text-blue-600 font-semibold hover:text-blue-800 transition-colors" data-id="element-115">
                <PhoneIcon className="w-5 h-5 mr-2" data-id="element-116" />
                <span data-id="element-117">Call our emergency line: 01234 567890</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
export default Contact;